export default `
<section class="bg-white first container">
    <div class="href center"><a href="++{{section10link}}">++{{section10linktext}}</a></div>
</section>
`